
  (function () {
    if (window.BHWishlist) return;
    var STORAGE_KEY = 'bh_wishlist_v1';
    var EVT_CHANGE = 'bh:wishlist:change';
    var listeners = [];
    var pageHandle = '/pages/wishlist';
    var t_strings = {
      ar: {
        added:   'تمت الإضافة إلى المفضلة',
        removed: 'تم الحذف من المفضلة',
        empty:   'لا توجد منتجات في المفضلة',
        emptySub:'احفظ القطع التي تناسب ذوقك في المفضلة، لتعود إليها وتكمل اختيارك في أي وقت.',
        startCta:'متابعة التسوق',
        wishlist:'المفضلة',
        add:     'أضف إلى السلة',
        sold:    'غير متوفر'
      },
      en: {
        added:   'Added to wishlist',
        removed: 'Removed from wishlist',
        empty:   'No favorites yet',
        emptySub:'Tap the heart on any product to save it here for later.',
        startCta:'Continue shopping',
        wishlist:'Wishlist',
        add:     'Add to cart',
        sold:    'Sold out'
      }
    };

    var lang = (document.documentElement.lang || 'ar').toLowerCase().indexOf('en') === 0 ? 'en' : 'ar';
    var T = t_strings[lang];

    function readRaw() {
      try {
        var v = localStorage.getItem(STORAGE_KEY);
        if (!v) return { version: 1, items: [] };
        var parsed = JSON.parse(v);
        if (!parsed || typeof parsed !== 'object') return { version: 1, items: [] };
        if (!Array.isArray(parsed.items)) parsed.items = [];
        return parsed;
      } catch (e) { return { version: 1, items: [] }; }
    }
    function writeRaw(state) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
    }
    var TOMB_KEY = 'bh_wishlist_tomb_v1';
    var TOMB_TTL = 14 * 24 * 60 * 60 * 1000; // 14d
    function readTomb() {
      try { var t = JSON.parse(localStorage.getItem(TOMB_KEY) || '{}'); return (t && typeof t === 'object') ? t : {}; }
      catch (e) { return {}; }
    }
    function writeTomb(t) { try { localStorage.setItem(TOMB_KEY, JSON.stringify(t)); } catch (e) {} }
    function tombstone(id) { var t = readTomb(); t[String(Number(id))] = Date.now(); writeTomb(t); }
    function clearTomb(id) { var t = readTomb(); var k = String(Number(id)); if (t[k] !== undefined) { delete t[k]; writeTomb(t); } }
    function isTombstoned(id) {
      var t = readTomb(); var ts = t[String(Number(id))];
      if (!ts) return false;
      if (Date.now() - ts > TOMB_TTL) { clearTomb(id); return false; } // expired → forget
      return true;
    }
    function ids() { return readRaw().items.map(function (i) { return Number(i.id); }); }
    function has(id) {
      id = Number(id);
      return readRaw().items.some(function (i) { return Number(i.id) === id; });
    }
    function add(id, options) {
      id = Number(id);
      if (!id) return false;
      if (isTombstoned(id)) return false;
      var state = readRaw();
      if (state.items.some(function (i) { return Number(i.id) === id; })) return false;
      var entry = { id: id, added_at: Date.now() };
      if (options && typeof options === 'object') {
        if (options.variant) entry.variant = Number(options.variant) || null;
        if (options.handle)  entry.handle = String(options.handle);
      } else if (options) {
        entry.variant = Number(options) || null;
      }
      state.items.push(entry);
      writeRaw(state);
      emit('add', id, entry.variant);
      return true;
    }
    function remove(id) {
      id = Number(id);
      if (!id) return false;
      var state = readRaw();
      var before = state.items.length;
      state.items = state.items.filter(function (i) { return Number(i.id) !== id; });
      if (state.items.length === before) return false;
      writeRaw(state);
      tombstone(id); // block the app's add-only re-push from resurrecting it
      emit('remove', id);
      return true;
    }
    function toggle(id, options) {
      return has(id) ? (remove(id), false) : (clearTomb(id), add(id, options), true);
    }
    function clear() {
      writeRaw({ version: 1, items: [] });
      emit('clear');
    }
    function clearLocalSilent() {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      try { localStorage.removeItem(TOMB_KEY); } catch (e) {}
    }
    function applyFromApp(remoteIds) {
      if (!Array.isArray(remoteIds)) return;
      var local = readRaw();
      var bySource = {};
      local.items.forEach(function (i) { bySource[Number(i.id)] = i; });
      var nextItems = remoteIds.map(function (raw) {
        var id = Number(raw && (raw.id || raw)) || 0;
        if (!id) return null;
        var existing = bySource[id];
        if (existing) {
          if (!existing.handle && raw && raw.handle) {
            existing.handle = String(raw.handle);
          }
          return existing;
        }
        var entry = { id: id, variant: (raw && raw.variant) || null, added_at: Date.now() };
        if (raw && raw.handle) entry.handle = String(raw.handle);
        return entry;
      }).filter(Boolean)
        .filter(function (it) { return !isTombstoned(it.id); });
      writeRaw({ version: 1, items: nextItems });
      emit('replace');
    }

    function emit(action, id, variant) {
      var raw = readRaw();
      var idList = raw.items.map(function (i) { return Number(i.id); });
      var snapshot = { ids: idList, items: raw.items, count: idList.length, action: action, id: id || null, variant: variant || null };
      var propagate = function () {
        try {
          document.dispatchEvent(new CustomEvent(EVT_CHANGE, { detail: snapshot }));
        } catch (e) {}
        listeners.forEach(function (fn) { try { fn(snapshot); } catch (e) {} });

        try {
          if (window.WishlistChannel && window.WishlistChannel.postMessage) {
            window.WishlistChannel.postMessage(JSON.stringify(snapshot));
          }
        } catch (e) {}

        try {
          window.dataLayer = window.dataLayer || [];
          if (action === 'add')    window.dataLayer.push({ event: 'wishlist_add', product_id: id });
          if (action === 'remove') window.dataLayer.push({ event: 'wishlist_remove', product_id: id });
          if (action === 'clear')  window.dataLayer.push({ event: 'wishlist_clear' });
        } catch (e) {}
      };
      if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(propagate);
      else setTimeout(propagate, 0);
    }

    window.addEventListener('storage', function (e) {
      if (e.key !== STORAGE_KEY) return;
      emit('external');
      renderHearts();
      updateBadges();
    });

    var SVG_HEART =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
      '</svg>';

    function buildHeart(productId, variantId, handle, pdpStyle) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bh-heart' + (pdpStyle ? ' bh-heart--pdp' : '');
      btn.setAttribute('data-bh-heart', '1');
      btn.setAttribute('data-product-id', String(productId));
      if (variantId) btn.setAttribute('data-variant-id', String(variantId));
      if (handle)    btn.setAttribute('data-product-handle', String(handle));
      btn.setAttribute('aria-pressed', has(productId) ? 'true' : 'false');
      btn.setAttribute('aria-label', T.wishlist);
      btn.innerHTML = SVG_HEART;
      if (!pdpStyle) {
        btn.style.top = '4px';
        btn.style.left = '4px';
        btn.style.right = 'auto';
        btn.style.bottom = 'auto';
      }
      if (has(productId)) btn.classList.add('is-active');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var willBeActive = !has(productId);
        btn.classList.toggle('is-active', willBeActive);
        btn.setAttribute('aria-pressed', willBeActive ? 'true' : 'false');
        btn.classList.add('is-pulsing');
        setTimeout(function () { btn.classList.remove('is-pulsing'); }, 220);
        if (willBeActive) { clearTomb(productId); add(productId, { variant: variantId, handle: handle }); }
        else remove(productId);
        if (typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(function () { renderHearts(); updateBadges(); });
        } else { renderHearts(); updateBadges(); }
      });
      return btn;
    }

    function isProductPage() {
      return document.body && document.body.className.indexOf('template-product') !== -1;
    }

    function getPdpProductData() {
      var pid = 0;
      var handle = '';
      var idEl = document.querySelector('form[action*="/cart/add"] input[name="product-id"], [data-product-json], [data-product-id]');
      if (idEl) pid = Number(idEl.getAttribute('data-product-id') || idEl.value || 0);
      if (!pid) {
        var jsonNode = document.querySelector('[id^=ProductJson-]');
        try {
          if (jsonNode) {
            var parsed = JSON.parse(jsonNode.textContent);
            pid = Number(parsed.id);
            handle = parsed.handle || '';
          }
        } catch (e) {}
      }
      if (!handle) {
        var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
        if (m) handle = decodeURIComponent(m[1]);
      }
      return { id: pid, handle: handle };
    }

    function injectIntoCards(root) {
      root = root || document;
      if (isProductPage()) return;
      var nodes = root.querySelectorAll('[data-product-id]:not([data-bh-heart-injected])');
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node.matches('form') || node.matches('button')) continue;
        if (node.closest('.quick-add-modal, .quick-shop-modal, .slideshow-wrapper, .flickity-slider, .swiper, .swiper-wrapper, .slick-slider, .slick-track, [class*="slider"], [class*="carousel"], [id*="Slider"], [data-slider]')) continue;
        var pid = Number(node.getAttribute('data-product-id'));
        if (!pid) continue;
        var handle = node.getAttribute('data-product-handle') || '';
        var target = node.querySelector('.grid-product__image-wrap') || node;
        var heartHost = node.querySelector('.grid-item__content') || target;
        heartHost.classList.add('bh-heart-host');
        var heartEl = buildHeart(pid, null, handle, false);
        heartHost.appendChild(heartEl);
        node.setAttribute('data-bh-heart-injected', '1');
        try {
          var carryRoot = node.closest('.na-card, .pg-card, .sg-card, .bs-card');
          if (carryRoot) {
            var stray = carryRoot.querySelector(':scope > .grid-product__new-badge');
            if (stray && stray.parentElement !== target) {
              target.appendChild(stray);
            }
          }

          var czNew  = target.querySelector(':scope > .grid-product__new-badge');
          var czDisc = target.querySelector(':scope > .grid-product__discount-badge');
          if (czNew || czDisc) {
            var HEART_TOP = 4;
            var HEART_END = 4;
            var HEART_H   = 30;
            var BADGE_H   = 24;
            var PAD       = 6; // visually consistent on mobile + desktop
            var nextTop = HEART_TOP + HEART_H + PAD;
            if (czNew) {
              czNew.style.top = nextTop + 'px';
              czNew.style.left = HEART_END + 'px';
              czNew.style.right = 'auto';
              target.classList.add('cz-card--has-new');
              nextTop = nextTop + BADGE_H + PAD;
            }
            if (czDisc) {
              czDisc.style.top = nextTop + 'px';
              czDisc.style.left = HEART_END + 'px';
              czDisc.style.right = 'auto';
            }
          }
        } catch (e) { }
      }
    }

    function injectIntoPdp() {
      if (!isProductPage() || document.querySelector('.bh-heart--pdp')) return;
      if (!document.querySelector('[data-bh-pdp-heart]')) return;
      var product = getPdpProductData();
      if (!product.id) return;
      var title = document.querySelector(
        '.product-single__title, .product__title, .product-single__meta h1, .product-template__title h1, h1.product-single__title, .product-single__meta .element-text--heading-xl, .product-single__meta .element-text--heading-2xl'
      );
      if (!title) return;
      if (!title.classList.contains('bh-wishlist-title-inline')) {
        title.classList.add('bh-wishlist-title-inline');
        title.style.display = 'inline-flex';
        title.style.alignItems = 'center';
        title.style.gap = '6px';
      }
      title.appendChild(buildHeart(product.id, null, product.handle, true));
    }

    function renderHearts() {
      var set = Object.create(null);
      readRaw().items.forEach(function (i) { set[Number(i.id)] = true; });
      var nodes = document.querySelectorAll('.bh-heart');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        var active = !!set[Number(n.getAttribute('data-product-id'))];
        n.classList.toggle('is-active', active);
        n.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }

    function updateBadges() {
      var c = ids().length;
      var bubbles = document.querySelectorAll('.bh-wishlist-count');
      for (var i = 0; i < bubbles.length; i++) {
        bubbles[i].textContent = c > 99 ? '99+' : String(c);
        bubbles[i].classList.toggle('bh-wishlist-link__bubble--visible', c > 0);
      }
    }

    function hydrate() {
      injectIntoCards();
      injectIntoPdp();
      updateBadges();
    }

    document.addEventListener('contextmenu', function (e) {
      try { if (e.target && e.target.closest && e.target.closest('.grid-item.grid-product, .grid-product__image-wrap, .bh-heart')) e.preventDefault(); } catch (x) {}
    });
    document.addEventListener('dragstart', function (e) {
      try { if (e.target && e.target.closest && e.target.closest('.grid-item.grid-product')) e.preventDefault(); } catch (x) {}
    });

    function bhPressCard(t) {
      if (!t || !t.closest) return null;
      if (t.closest('.bh-heart, .grid-product__actions, .quick-add-btn, button, [data-single-variant-quick-add]')) return null;
      return t.closest('.grid-item.grid-product');
    }
    function bhClearPressed() {
      var els = document.querySelectorAll('.grid-item.grid-product.bh-pressed');
      for (var i = 0; i < els.length; i++) els[i].classList.remove('bh-pressed');
    }
    document.addEventListener('pointerdown', function (e) {
      var c = bhPressCard(e.target);
      if (c) c.classList.add('bh-pressed');
    }, { passive: true });
    ['pointerup', 'pointercancel', 'pointerleave', 'dragstart'].forEach(function (ev) {
      document.addEventListener(ev, bhClearPressed, { passive: true });
    });
    document.addEventListener('scroll', bhClearPressed, { passive: true, capture: true });
    document.addEventListener('touchmove', bhClearPressed, { passive: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hydrate);
    } else {
      hydrate();
    }

    try {
      var moPending = false;
      function scheduleSweep() {
        if (moPending) return;
        moPending = true;
        var run = function () {
          moPending = false;
          injectIntoCards();
          renderHearts();
        };
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(run, { timeout: 500 });
        } else {
          window.requestAnimationFrame(function () { setTimeout(run, 0); });
        }
      }
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            scheduleSweep();
            return;
          }
        }
      });
      mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
      window.addEventListener('beforeunload', function () {
        try { mo.disconnect(); } catch (e) {}
      });
    } catch (e) {}

    window.BHWishlist = {
      add: function (id, variant) { var r = add(id, variant); renderHearts(); updateBadges(); return r; },
      remove: function (id) { var r = remove(id); renderHearts(); updateBadges(); return r; },
      toggle: function (id, variant) { var r = toggle(id, variant); renderHearts(); updateBadges(); return r; },
      has: has,
      list: function () { return readRaw().items.slice(); },
      ids: ids,
      count: function () { return ids().length; },
      clear: function () { clear(); renderHearts(); updateBadges(); },
      clearLocalSilent: function () { clearLocalSilent(); renderHearts(); updateBadges(); },
      applyFromApp: function (remoteIds) { applyFromApp(remoteIds); renderHearts(); updateBadges(); },
      subscribe: function (fn) { listeners.push(fn); return function () {
        var i = listeners.indexOf(fn); if (i >= 0) listeners.splice(i, 1);
      }; },
      pageUrl: function () {
        var enPrefix = location.pathname.indexOf('/en') === 0 ? '/en' : '';
        return enPrefix + '/pages/wishlist';
      },
      open: function () { location.href = this.pageUrl(); },
      strings: function () { return T; },
      refreshPdp: function () { injectIntoPdp(); renderHearts(); }
    };

    try {
      if (window.WishlistChannel && window.WishlistChannel.postMessage) {
        var snap = { ids: ids(), items: readRaw().items, count: ids().length, action: 'init', id: null, variant: null };
        window.WishlistChannel.postMessage(JSON.stringify(snap));
      }
    } catch (e) {}
  })();
